import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ErrorBoundary from '@/components/ErrorBoundary';
import App from './App.tsx';
import { initAnalytics } from '@/utils/analytics';
import { initPostHog } from '@/utils/posthog';
import './index.css';

initAnalytics();
initPostHog();

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <App />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              className: '',
              style: {},
              success: {
                duration: 3000,
                className: '!bg-green-50 !text-green-800 dark:!bg-green-900 dark:!text-green-200 !border-green-200 dark:!border-green-700',
              },
              error: {
                duration: 5000,
                className: '!bg-red-50 !text-red-800 dark:!bg-red-900 dark:!text-red-200 !border-red-200 dark:!border-red-700',
              },
              loading: {
                className: '!bg-blue-50 !text-blue-800 dark:!bg-blue-900 dark:!text-blue-200 !border-blue-200 dark:!border-blue-700',
              },
            }}
          />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);